import { Point } from '@ng-cloud/badger-core/models/interfaces/point';
import { RfidTag } from '@ng-cloud/badger-core/models/rfid-tag';
import { Circle, FabricObject } from 'fabric';
import { MapObject } from './map-object';

export class RfidTagObject extends MapObject {
  defaultOptions: any = {
    objectCaching: false,
    selectable: false,
    evented: false,
    lockMovementX: true,
    lockMovementY: true,
    lockScalingX: true,
    lockScalingY: true,
    lockRotation: true,
    hasControls: false,
    top: this.points[0].y,
    left: this.points[0].x,
    radius: 1,
    originX: 'center',
    originY: 'center',
    opacity: 1,
    fill: 'rgba(10, 141, 255, 0.65)',
    strokeWidth: .15,
    stroke: 'rgba(72, 87, 106, 0.75)'
  };

  constructor(public rfidTag: RfidTag, private points: Point[], config?: any) {
    super(config);

    this.rfidTag = rfidTag;
  }

  protected build(): FabricObject {
    return new Circle(this.getOptions());
  };
}

